import React from "react";
import { useNavigate } from "react-router-dom";

function ProfilePicture({ src, size, styles, profileUrl }) {
  const sizeInRem = size / 16; // Convert size from px to rem
  const sizeStyle = {
    width: `${sizeInRem}rem`,
    height: `${sizeInRem}rem`,
  };
  const navigate = useNavigate();

  return (
    <img
      src={src}
      alt="Profile"
      style={sizeStyle}
      className={`rounded-full ${styles} cursor-pointer`}
      onClick={() => navigate(profileUrl)}
    />
  );
}

export { ProfilePicture };
